export default __webpack_public_path__ + "static/media/AcornMallFastFood_33.71705fb4.png";